export default __webpack_public_path__ + "static/juba-3a412d77cb397e33c6ea36137b89738c.png";